import { EventNames } from '../../types/misc.types'
import { trackEvent } from '../../utils/appBridge'
import Button from '../ui-components/Button'
import { useNavigate } from 'react-router-dom'

type PowerRebalancingEliteButtonPropTypes = {
  isButtonDisabled?: boolean
  theme?: 'ELITE' | 'INVERTED_ELITE'
}

export const PowerRebalancingEliteButton = ({
  theme = 'ELITE',
  isButtonDisabled
}: PowerRebalancingEliteButtonPropTypes) => {
  const { topLayerBg, topLayerTextColor, buttonBg, buttonTextColor } = eliteButtonConfig?.[theme]
  const navigate = useNavigate()

  const getEliteButtonTextColor = () => {
    if (isButtonDisabled) return '!text-[#88898C]'
    return buttonTextColor
  }

  const getEliteButtonBg = () => {
    if (isButtonDisabled) return '!bg-[#4B4C4E]'
    return buttonBg
  }

  return (
    <div className='flex flex-col w-full'>
      <div className={`relative h-[80px] z-0 rounded-[12px] ${topLayerBg}`}>
        <div className='h-[75px]'></div>
        <div
          className={`absolute flex w-full justify-center items-center pb-8 px-[13px] ${topLayerTextColor} z-10 top-[5px] text-[13px]`}
        >
          Unlock&nbsp;<b> Power Rebalance, Ranks </b>&nbsp;and a lot more
        </div>
      </div>
      <Button
        onClick={() => {
          trackEvent({
            eventName: EventNames.ButtonTap,
            payload: {
              buttonLabel: 'Upgrade to Elite',
              screenType: 'MF_Smart_Rebalancing'
            }
          })
          navigate('/elite?isWhitelisted=true')
        }}
        buttonClassName={`min-h-[56px] min-w-full mt-[-44px] font-[500] z-10 !text-[16px] rounded-[12px] ${getEliteButtonBg()}`}
      >
        <div className='flex gap-2 items-center justify-center'>
          <div className={`pb-[2px] ${getEliteButtonTextColor()}`}>{'Upgrade to Elite'}</div>
        </div>
      </Button>
    </div>
  )
}

const eliteButtonConfig = {
  ['ELITE']: {
    topLayerBg: 'bg-gradient-to-br from-[#2B3238] to-[#171B20]',
    topLayerTextColor: 'text-[#FEFFFE]',
    buttonBg: '!bg-[#FFF2DF]',
    buttonTextColor: '!text-[#722200]'
  },
  ['INVERTED_ELITE']: {
    topLayerBg: 'bg-[#FFF2DF]',
    topLayerTextColor: 'text-[#CC5C2D]',
    buttonBg: '!bg-[#232323]',
    buttonTextColor: '!text-[#FEFFFE]'
  }
}
